import { useMemo, type FC } from 'react';

import { ApprovalStatusBar } from '@mint-lib/approval-flow-circuit_v2';

import useFlightsApi from '../../../../../api/queries/useFlightsApi.js';
import { useSidebarTreeApi } from '../../../../../api/queries/useSidebarTreeApi.js';

type Props = {
  flightMediaDataId: string;
  flightName: string;
  flightCurrency: string;
};

const ApprovalCircuit: FC<Props> = ({
  flightMediaDataId,
  flightName,
  flightCurrency,
}) => {
  const { data: sidebarTree } = useSidebarTreeApi();

  const activityId = useMemo(() => {
    const foundActivity = sidebarTree?.subItems.find((activity) =>
      activity.subItems.some(
        (flight) => flight.mediaDataId === flightMediaDataId,
      ),
    );

    return foundActivity?.activityId ?? '';
  }, [flightMediaDataId, sidebarTree]);

  const { data: flightsData } = useFlightsApi(activityId, !!activityId);

  const flightData = useMemo(() => {
    return flightsData?.items.find((flight) => flight.name === flightName);
  }, [flightName, flightsData]);

  if (!flightData) {
    return null;
  }

  return (
    <ApprovalStatusBar
      entityType="flight"
      entityId={flightData.id}
      entityName={flightData.name}
      entitySource="planning-service"
      entityMetadata={{
        trackedFields: {
          dateFrom: flightData.dateFrom,
          dateTo: flightData.dateTo,
          budget: flightData.budget,
          currency: flightCurrency,
        },
      }}
    />
  );
};

export default ApprovalCircuit;
